import axios from "axios";

// Same-origin API calls so login cookies are first-party on every domain
// (bekindevents1.org, emergent.host, preview). Falls back to the env URL for local dev.
export const API =
  window.location.hostname === "localhost"
    ? `${process.env.REACT_APP_BACKEND_URL}/api`
    : "/api";

export const api = axios.create({ baseURL: API, withCredentials: true });

export function apiError(e, fallback = "Something went wrong. Please try again.") {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : "")).filter(Boolean).join(" ") || fallback;
  return fallback;
}
